import { Navigation } from "./Navigation";

export class Breadcrumb {
    private static breadcrumbs: kendo.ui.Breadcrumb;
    private static breadcrumbItems: kendo.ui.BreadcrumbItem[];

    /**
     * Add a new breadcrumb item.
     * @param text The text in the breadcrumb.
     * @param url The url the breadcrumb points to.
     * @since 5.1.0
     */
    public static add(text: string, url: string) {
        this.breadcrumbItems.push({
            type: "item",
            text: text,
            href: url?.replace("~", ""),
        });
        this.breadcrumbs.items(this.breadcrumbItems);
    }

    /**
     * Remove the last breadcrumb item.
     * @since 5.1.0
     */
    public static removeLast() {
        if (this.breadcrumbItems.length > 1) {
            this.breadcrumbItems.pop();
            this.breadcrumbs.items(this.breadcrumbItems);
        }
    }

    /**
     * Sets the root of the breadcrumb navigation.
     * @param text The text of the root item.
     * @param url The url of the root item.
     * @since 5.1.0
     */
    public static setRoot(text: string, url: string) {
        this.breadcrumbItems = [
            {
                type: "rootitem",
                text: text,
                href: (url ?? Navigation.getCurrentUrl()).replace("~", ""),
                showIcon: false,
                showText: true,
            },
        ];
        this.breadcrumbs.items(this.breadcrumbItems);
    }

    /**
     * @hidden
     */
    public static initialize() {
        const wrapper = $(".dms-breadcrumb-wrapper");

        const container = $("<div class='dms-breadcrumb-container'></div>");
        wrapper.append(container);

        this.breadcrumbItems = [];
        this.breadcrumbs = new kendo.ui.Breadcrumb(container[0], {
            items: this.breadcrumbItems,
            rootIcon: "",
            click: (e) => {
                if (e.item) {
                    // Remove all breadcrumb items after the clicked item
                    const idx = this.breadcrumbItems.findIndex((bi) => bi === e.item);
                    if (idx > -1 && idx < this.breadcrumbItems.length - 1) {
                        this.breadcrumbItems = this.breadcrumbItems.slice(0, idx + 1);
                    }
                    Navigation.navigate(e.item.href);
                }
            },
        });

        wrapper.removeClass("dms-hidden");
    }
}
